/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */

import { hasAccessRights } from "./PermissionUtils";

/**
 * Rules.Navigation: Rules that decides user navigation across app
 * Rules.Control: Rules that decides user actions available on a particular page
 */
const Rules = {
  Navigation: {},
  Control: {
    VIEW_SEASONS_LIST: () => hasAccessRights(["ViewSeasonsList"]),
    ADD_SEASON: () => hasAccessRights(["AddSeason"]),
    EDIT_SEASON: () => hasAccessRights(["EditSeason"]),
    DELETE_SEASON: () => hasAccessRights(["DeleteSeason"]),
    SEARCH_SEASON: () => hasAccessRights(["SearchSeason"]),
    VIEW_SEASONS_LINK: () => hasAccessRights(["ViewSeasonsLink"]),
    VIEW_CUSTOMERS_LIST: () => hasAccessRights(["ViewCustomersList"]),
    EDIT_CUSTOMER: () => hasAccessRights(["EditCustomer"]),
    DOWNLOAD_CUSTOMER_LIST: () => hasAccessRights(["DownloadCustomerList"]),
    SEARCH_CUSTOMER: () => hasAccessRights(["SearchCustomer"]),
    VIEW_CUSTOMERS_LINK: () => hasAccessRights(["ViewCustomersLink"]),
    VIEW_BRANDS_LINK: () => hasAccessRights(["ViewProductBrandList"]),
    VIEW_BRANDS_LIST: () => hasAccessRights(["ViewProductBrandsLink"]),
    ADD_BRAND: () => hasAccessRights(["AddProductBrand"]),
    EDIT_BRAND: () => hasAccessRights(["EditProductBrand"]),
    DELETE_BRAND: () => hasAccessRights(["DeleteProductBrand"]),
    SEARCH_BRAND: () => hasAccessRights(["SearchProductBrand"]),
  },
};

export default Rules;
